import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { CcRequirement } from "server/models"
import { deepCopy } from "client/utils"
import {
    StoreType,
    setNotAssignedCcRequirementSelected,
} from "client/store"
import {
    DateFormatter,
    TableColumn,
    UserIcon,
    NotAssigned,
} from "client/components"

const Columns = () => {
    const selected = useSelector((state: StoreType) => state.ccRequirement.notAssigned.selected)
    const typeList = useSelector((state: StoreType) => state.ccRequirementType.typeList)
    const priorityList = useSelector((state: StoreType) => state.ccRequirementPriority.priorityList)
    const statusList = useSelector((state: StoreType) => state.ccRequirementStatus.statusList)

    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectRequirement = (requirement: CcRequirement) => {
        let selectedCopy
        if (selected && selected.includes(requirement.id)) {
            selectedCopy = selected.filter((id) => (id !== requirement.id))
        } else {
            selectedCopy = selected ? deepCopy(selected) : []
            selectedCopy.push(requirement.id)
        }
        dispatch(setNotAssignedCcRequirementSelected(selectedCopy))
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            onClick: selectRequirement,
        },
        {
            field: "uniqueId",
            header: lang.uniqueId,
            sortable: true,
            cellMinWidth: "150px",
            cellMaxWidth: "250px",
            onClick: selectRequirement,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            cellMaxWidth: "300px",
            onClick: selectRequirement,
        },
        {
            field: "creator",
            header: lang.createdBy,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (requirement: CcRequirement) => {
                const user = userList[requirement.creator]
                return <UserIcon user={user} size="sm" />
            },
            onClick: selectRequirement,
        },
        {
            field: "type",
            header: lang.type,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (requirement: CcRequirement) => {
                const type = typeList[requirement.typeId]
                return type ? type.name : <NotAssigned />
            },
            onClick: selectRequirement,
        },
        {
            field: "priority",
            header: lang.priority,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (requirement: CcRequirement) => {
                const priority = priorityList[requirement.priorityId]
                return priority ? priority.name : <NotAssigned />
            },
            onClick: selectRequirement,
        },
        {
            field: "status",
            header: lang.status,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (requirement: CcRequirement) => {
                const status = statusList[requirement.statusId]
                return status ? status.name : <NotAssigned />
            },
            onClick: selectRequirement,
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            formatter: (requirement: CcRequirement) => <DateFormatter date={requirement.createdAt} />,
            onClick: selectRequirement,
        },
    ]

    return columns
}
export default Columns
